﻿"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateActiveDrivers = void 0;
const gs = require("@ivanlog/gs");
const com = require("../../com/tmpls");
const StatePaged_1 = require("../abstracts/StatePaged");
const gs_1 = require("@ivanlog/gs");
class StateActiveDrivers extends StatePaged_1.StatePaged {
    constructor() {
        super(com.PageList, "Active drivers", true);
        this._callbackOnSelect = null;
    }
    static SelectActiveDriver() {
        return new Promise((resolve, reject) => {
            gs_1.StateGS.Run(StateActiveDrivers, { callbackOnSelect: resolve });
        });
    }
    start(arg) {
        const _super = Object.create(null, {
            start: { get: () => super.start }
        });
        return __awaiter(this, void 0, void 0, function* () {
            if (arg) {
                this._callbackOnSelect = arg.callbackOnSelect;
                if (this._callbackOnSelect)
                    this.title = "Select active driver:";
            }
            var drivers = yield this.lockgui(this.app.api.admin.activeManager.getActiveVehiclesFull(0, 100));
            yield this.fill(drivers);
            return _super.start.call(this);
        });
    }
    fill(activeDrivers) {
        return __awaiter(this, void 0, void 0, function* () {
            this.page.ctrls.list.html = '';
            this.page.ctrls.btnNew.hide();
            for (const active of activeDrivers) {
                const item = new com.ListItem();
                item.ctrls.lType.text = "Active vehicle";
                item.ctrls.lId.text = `#${active.driver.userId}`;
                let data = [gs.text.clearHtmlToText(`State: ${active.state}`),
                    gs.text.clearHtmlToText(`Name: ${active.driverUser.name} ${active.driverUser.surname}`),
                    gs.text.clearHtmlToText(`Vehicle: ${active.vehicle.model} ${active.vehicle.color}`),
                    gs.text.clearHtmlToText(`Gov.number: ${active.vehicle.govNumber} `)
                ];
                item.ctrls.pData.html = data.join('<br>');
                this.page.ctrls.list.append(item);
                if (this._callbackOnSelect)
                    item.onclick = () => this._callbackOnSelect(active);
            }
        });
    }
}
exports.StateActiveDrivers = StateActiveDrivers;
StateActiveDrivers.StateName = "activeDrivers";
//# sourceMappingURL=StateActiveDrivers.js.map